Vue.component('navigation', {
  template: templates.navigation2,
  data() {
    return {
      model: {
        page: 'cards',
        cards: 'yours'
      }
    }
  },
  methods: {
    click(page) {
      const c = this;
      c.model.page = page;
      c.$root.$emit('showPage', page);
    },
    cards(page) {
      const c = this;
      c.model.cards = page;
      c.$root.$emit('showCards', page);

      c.$nextTick(() => {
        $('.playing-card:not(.disabled)').addClass('flipped');
      });
    }
    
  }
})

const vueApp = new Vue({
  el: '[data-view="viewer-dashboard"]',
  data() {
    return {
      model: {
        page: 'cards',
        cards: 'yours',
        faction: {
          position: { x: 1952, y: 66 },
          isDragging: false,
          offsetX: 0,
          offsetY: 0,
        },
        userFaction:{}
      }
    }
  },
  mounted() {
    const c = this;
    c.$root.$on('showPage', page => {
      c.model.page = page;


      console.log(page)
    });

    c.$root.$on('showCards', page => {
      c.model.cards = page;
    });

    // c.$root.$on('openFaction', data =>{
    //   c.model.userFaction = data
    // })


  },
  methods: {
    
    startDragging(event) {
      const c = this;
      c.model.faction.isDragging = true;
      c.model.faction.offsetX = event.clientX - c.model.faction.position.x;
      c.model.faction.offsetY = event.clientY - c.model.faction.position.y;

      document.addEventListener('mousemove', c.drag);
      document.addEventListener('mouseup', c.stopDragging);
    },
    drag(event) {
      const c = this;
      if (c.model.faction.isDragging) {
        c.model.faction.position.x = event.clientX - c.model.faction.offsetX;
        c.model.faction.position.y = event.clientY - c.model.faction.offsetY;
      }
    },
    stopDragging() {
      const c = this;
      c.model.faction.isDragging = false;
      document.removeEventListener('mousemove', c.drag);
      document.removeEventListener('mouseup', c.stopDragging);
    },
    // openFaction(){
    //   const c = this;
    //   $('.open-faction').addClass('is-visible');
    //   $('.open-faction').addClass('is-above');
    //   const header = document.querySelector('.header');
    //   header.classList.toggle('z-index-zero'); 
    //   document.body.classList.add('modal-open');
      
    // },
  }
});